import React from 'react';
import { Context } from './Form';
import TextArea from 'components/TextArea';
import getFromObj from 'util/getFromObj';
import setInObj from 'util/setInObj';
import { view } from 'react-easy-state';

const FormTextArea = (props) => (
  <Context.Consumer>
    {(context) => {
      let curValue = getFromObj(context.value, props.field);
      if(curValue === undefined){
        if(props.default !== undefined) {
          setInObj(context.value, props.field, props.default);
          curValue = props.default;
        } else {
          curValue = '';
        }
      }
      return (
        <TextArea {...props} value={curValue} onChange={ (event) => { 
          context.updateValue(props.field, event.target.value);
          if(props.onChange) props.onChange(event.target.value);
        } } />
      )
    } }
  </Context.Consumer>
);

export default view(FormTextArea);